import { DeleteLocationResponse } from '@hakimo-ui/hakimo/types';
import { useAuthenticatedMutation } from '../shared/useAuthenticatedMutation';

export function useDeleteLocation(
  tenantId: string,
  locationId: number,
  onSuccess?: (data: DeleteLocationResponse) => void,
  onError?: (err: Error) => void
) {
  const url = `/v2/orm/admin/tenants/${tenantId}/locations/${locationId}`;
  const request = new Request(url, { method: 'DELETE' });

  return useAuthenticatedMutation<DeleteLocationResponse, void>(request, {
    onSuccessInvalidationKeys: [
      ['locations'],
      ['locationId', locationId.toString()],
      ['admin-tenants'],
      ['admin-tenant-details', tenantId],
    ],
    onSuccess,
    onError,
  });
}

export default useDeleteLocation;
